import * as React from 'react'

function MemberIcon(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width={26}
      height={26}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      viewBox="0 0 26 26"
      {...props}
    >
      <g clipPath="url(#member_svg__clip0)" fill="#1D1D1D">
        <path d="M10.029 10.4a5.206 5.206 0 005.2-5.2 5.206 5.206 0 00-5.2-5.2 5.206 5.206 0 00-5.2 5.2 5.206 5.206 0 005.2 5.2zm0-8.914A3.717 3.717 0 0113.743 5.2a3.714 3.714 0 11-3.714-3.714z" />
        <path d="M20.057 14.114a5.812 5.812 0 00-.722.05c-1.093-2.305-3.268-3.764-5.672-3.764h-.208a.74.74 0 00-.55.244l-2.876 3.173-2.874-3.173a.75.75 0 00-.55-.244h-.208C2.87 10.4 0 13.532 0 17.383v2.674a.743.743 0 00.743.743h13.422a5.943 5.943 0 005.892 5.2 5.943 5.943 0 100-11.886zM1.486 17.383c0-2.986 2.14-5.423 4.79-5.494l3.203 3.539a.766.766 0 001.102 0l3.2-3.533a4.834 4.834 0 014.083 2.641 5.944 5.944 0 00-3.7 4.775H1.487v-1.928zm18.571 7.131a4.457 4.457 0 110-8.913 4.457 4.457 0 010 8.913z" />
        <path d="M22.319 17.677l-3.189 3.188-1.334-1.33a.74.74 0 00-1.21.808c.037.09.092.171.161.24l1.857 1.857a.734.734 0 00.526.217.728.728 0 00.523-.217l3.714-3.714a.742.742 0 10-1.049-1.052v.003z" />
      </g>
      <defs>
        <clipPath id="member_svg__clip0">
          <path fill="#fff" d="M0 0h26v26H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

const ForwardRef = React.forwardRef(MemberIcon)
export default ForwardRef
